export const environment = {
  name: 'staging',
  production: false,
  api: 'https://api-staging.gutwin.net',
  socket: 'wss://api-staging.gutwin.net',
  sentryUrl: 'https://b7f6b076f3e44a54b7eb680e6365491d@sentry.io/226835'
};
